import { Fragment } from 'react'

export interface RenderField {
  key: string
  render: () => JSX.Element | null
}

export const searchContains = (term: string | undefined, searchList: string[]) =>
  !term || searchList.some(item => item.toLowerCase().includes(term.toLowerCase()))

export const renderFields = (fields: RenderField[], filterTerm?: string) =>
  fields
    .filter(field => (filterTerm ? searchContains(filterTerm, [field.key]) : field))
    .map((field, index) => <Fragment key={`${field.key}-${index}`}>{field.render()}</Fragment>)
